import { ClipboardList, CheckCircle, LayoutList, FileText } from "lucide-react";
import type { StatCardConfig } from "../../common";

/** Creation-page stat cards — same keys/values as current frontend, token styling. */
export const CREATION_STATS_CARDS: StatCardConfig[] = [
  {
    key: "total",
    label: "Total Surveys",
    icon: ClipboardList,
    iconBg: "var(--color-primary-100)",
    iconColor: "var(--color-primary-700)",
  },
  {
    key: "published",
    label: "Published",
    icon: CheckCircle,
    iconBg: "var(--color-success-light)",
    iconColor: "var(--color-success-dark)",
  },
  {
    key: "templates",
    label: "Templates",
    icon: LayoutList,
    iconBg: "var(--color-secondary-100)",
    iconColor: "var(--color-secondary-600)",
  },
  {
    key: "drafts",
    label: "Drafts",
    icon: FileText,
    iconBg: "var(--color-warning-light)",
    iconColor: "var(--color-warning-dark)",
  },
];
